import { history } from '../store/index';
import { store } from '../../NextApp';
import { generateQueryString } from "../../util/Api";

import {
  CREATE_FLEET_TRIP_SUCCESS,
  FETCH_FLEET_TRIP_SUCCESS,
  GET_FLEET_TRIP_SUCCESS,
  SAVE_FLEET_TRIP_QUERY
} from "../../constants/ActionTypes";

import axios from 'util/Api'
import { fetchError, fetchStart, fetchSuccess } from "./Common";
import { message } from "antd";
import { arrayToCSV, downloadCSV } from '../../util/methods';

export const getResourceSuccess = ({ data, count }) => {
  return {
    type: GET_FLEET_TRIP_SUCCESS,
    data,
    count
  };
};

export const saveResourceQuery = (query) => {
  return {
    type: SAVE_FLEET_TRIP_QUERY,
    query
  };
};

export const createResourceSuccess = ({ data }) => {
  return {
    type: CREATE_FLEET_TRIP_SUCCESS,
    data
  };
};

export const fetchResourceSuccess = ({ data }) => {
  return {
    type: FETCH_FLEET_TRIP_SUCCESS,
    data
  };
};

export const getResource = () => {
  return async (dispatch) => {
    dispatch(fetchStart());
    try {
      const { fleetTrip } = store.getState();
      const { query } = fleetTrip;
      const response = await axios.get(`/fleet-trip?${generateQueryString(query)}`);
      dispatch(fetchSuccess());
      dispatch(getResourceSuccess(response.data));
    } catch (error) {
      console.log("Error****:", error);
      dispatch(fetchError(error.response && error.response.data && error.response.data.message));
    }
  }
};

// Builds multipart form data: new files under 'files', dates as ISO, objects/arrays as JSON.
const buildFleetTripFormData = (payload) => {
  const documents = payload.documents;
  const formData = new FormData();
  if (Array.isArray(documents) && documents.length) {
    documents.forEach((file) => {
      formData.append('files', file);
    });
  }
  Object.keys(payload).forEach((key) => {
    if (key === 'documents' || payload[key] === undefined || payload[key] === null) {
      return;
    }
    const value = payload[key];
    if (value && typeof value.toISOString === 'function') {
      formData.append(key, value.toISOString());
    } else if (typeof value === 'object') {
      formData.append(key, JSON.stringify(value));
    } else {
      formData.append(key, value);
    }
  });
  return formData;
};

export const createResource = (payload) => {
  return async (dispatch) => {
    dispatch(fetchStart());
    try {
      const formData = buildFleetTripFormData(payload);
      const config = { headers: { 'Content-Type': 'multipart/form-data' } };
      const response = await axios.post(`/fleet-trip`, formData, config);
      if (response && response.data && response.data.code === 202) {
        message.error(response.data.message);
        dispatch(fetchSuccess());
      } else {
        dispatch(fetchSuccess());
        dispatch(createResourceSuccess({ data: response.data }));
        message.success('Fleet trip created');
        history.push('/fleet-trip');
        dispatch(getResource());
      }
    } catch (error) {
      const msg = error.response && error.response.data && error.response.data.message;
      message.error(msg || 'Failed to create fleet trip');
      dispatch(fetchError(error));
      console.log("Error****:", error);
    }
  }
};

export const updateResource = (payload, id) => {
  return async (dispatch) => {
    dispatch(fetchStart());
    try {
      const formData = buildFleetTripFormData(payload);
      const config = { headers: { 'Content-Type': 'multipart/form-data' } };
      const response = await axios.put(`/fleet-trip/${id}`, formData, config);
      if (response && response.data && response.data.code === 202) {
        message.error(response.data.message);
        dispatch(fetchSuccess());
      } else {
        dispatch(fetchSuccess());
        message.success('Fleet trip updated');
        history.push('/fleet-trip');
        dispatch(getResource());
      }
    } catch (error) {
      const msg = error.response && error.response.data && error.response.data.message;
      message.error(msg || 'Failed to update fleet trip');
      dispatch(fetchError(error));
      console.log("Error****:", error);
    }
  }
};

export const startTrip = (id, payload) => {
  return async (dispatch) => {
    dispatch(fetchStart());
    try {
      await axios.patch(`/fleet-trip/${id}/start`, payload);
      dispatch(fetchSuccess());
      message.success('Trip started');
      dispatch(getResource());
    } catch (error) {
      const msg = error.response && error.response.data && error.response.data.message;
      message.error(msg || 'Failed to start trip');
      dispatch(fetchError(error));
    }
  }
};

export const endTrip = (id, payload) => {
  return async (dispatch) => {
    dispatch(fetchStart());
    try {
      await axios.patch(`/fleet-trip/${id}/end`, payload);
      dispatch(fetchSuccess());
      message.success('Trip ended');
      dispatch(getResource());
    } catch (error) {
      const msg = error.response && error.response.data && error.response.data.message;
      message.error(msg || 'Failed to end trip');
      dispatch(fetchError(error));
    }
  }
};

export const addStatus = (id, payload) => {
  return async (dispatch) => {
    dispatch(fetchStart());
    try {
      await axios.patch(`/fleet-trip/${id}/status`, payload);
      dispatch(fetchSuccess());
      message.success('Status updated');
      dispatch(getResource());
    } catch (error) {
      const msg = error.response && error.response.data && error.response.data.message;
      message.error(msg || 'Failed to update status');
      dispatch(fetchError(error));
    }
  }
};

export const fetchResource = (id) => {
  return async (dispatch) => {
    dispatch(fetchStart());
    try {
      const response = await axios.get(`/fleet-trip/${id}`);
      dispatch(fetchSuccess());
      dispatch(fetchResourceSuccess({ data: response.data }));
    } catch (error) {
      dispatch(fetchError(error.response && error.response.data && error.response.data.message));
    }
  }
};

export const deleteResource = (id) => {
  return async (dispatch) => {
    dispatch(fetchStart());
    try {
      await axios.delete(`/fleet-trip/${id}`);
      dispatch(fetchSuccess());
      dispatch(getResource());
    } catch (error) {
      dispatch(fetchError(error.response && error.response.data && error.response.data.message));
    }
  }
};

export const getResourceForDownload = (columns, filters, name) => {
  return async (dispatch) => {
    dispatch(fetchStart());
    try {
      const { fleetTrip } = store.getState();
      const { query } = fleetTrip;
      const response = await axios.get(`/fleet-trip/download?columns=${columns}&${generateQueryString(query)}`);
      dispatch(fetchSuccess());
      const str = arrayToCSV(response.data, filters, columns);
      downloadCSV(str, name);
    } catch (error) {
      message.error(error.response && error.response.data && error.response.data.message);
      dispatch(fetchError(error.response && error.response.data && error.response.data.message));
    }
  }
};
